import { render, staticRenderFns } from "./AssetLabelsTable.vue?vue&type=template&id=24b18152"
import script from "./AssetLabelsTable.vue?vue&type=script&lang=js"
export * from "./AssetLabelsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports